import { Intercom } from '@ionic-native/intercom';

const intercomApiService = {
    registerUser(user) {
        return Intercom.registerIdentifiedUser(user)
    },

    updateUser(displayName) {
        return Intercom.updateUser({ name: displayName });
    },

    displayMessenger() {
        return Intercom.displayMessenger()
    },

    displayMessageComposer(supportCategory) {
        return Intercom.displayMessageComposerWithInitialMessage(`${supportCategory} Help: `)
    },

    displayLauncher() {
        return Intercom.displayLauncher()
    },

    registerPushAndroid(token) {
        return Intercom.sendPushTokenToIntercom(token)
    },
    registerPushIos() {
        return Intercom.registerForPush()
    },
    logout() {
        return Intercom.logout()
    }
}

export default intercomApiService
